import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #06d1c6",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};
const labelStyle = {
  display: "block",
  marginBottom: "6px",
  fontWeight: 600,
  color: "#475569",
  fontSize: "14px",
};

export default function FolioLookup() {
  const [folio, setFolio] = useState("");
  const [applicantMappedTo, setApplicantMappedTo] = useState("");
  const [applicantFolio, setApplicantFolio] = useState("");
  const [fund, setFund] = useState("");
  const [category, setCategory] = useState("all");
  const [rta, setRta] = useState("all");
  const [viewType, setViewType] = useState("on-screen"); // "on-screen" | "xls"
  const [detailBrief, setDetailBrief] = useState("detail"); // "detail" | "brief"
  const [showFolios, setShowFolios] = useState("active"); // "all" | "active"

  const handleApply = () => {
    // TODO: wire to API / table when ready
    console.log({
      folio,
      applicantMappedTo,
      applicantFolio,
      fund,
      category,
      rta,
      viewType,
      detailBrief,
      showFolios,
    });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <div className="content-page-header content-page-headersplit">
              <h5>Folio Lookup</h5>
            </div>
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Folio Lookup
                </li>
              </ol>
            </nav>
          </div>

          {/* Main container - light grey, rounded */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
            }}
          >
            {/* Filter Section */}
            <div style={{ marginBottom: "22px" }}>
              <span style={{ fontWeight: 700, color: "#334155", fontSize: "15px" }}>
                Filter :
              </span>
              <div className="row g-3 mt-1">
                <div className="col-12 col-md-6 col-lg-3">
                  <label style={labelStyle}>Folio</label>
                  <input
                    type="text"
                    placeholder="Search Folio"
                    value={folio}
                    onChange={(e) => setFolio(e.target.value)}
                    style={{ ...inputStyle, color: "#94a3b8" }}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <label style={labelStyle}>Applicant (Mapped To)</label>
                  <input
                    type="text"
                    placeholder="Type to Search..."
                    value={applicantMappedTo}
                    onChange={(e) => setApplicantMappedTo(e.target.value)}
                    style={{ ...inputStyle, color: "#94a3b8" }}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <label style={labelStyle}>Applicant (Folio)</label>
                  <input
                    type="text"
                    placeholder="Search Applicant"
                    value={applicantFolio}
                    onChange={(e) => setApplicantFolio(e.target.value)}
                    style={{ ...inputStyle, color: "#94a3b8" }}
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <label style={labelStyle}>Fund</label>
                  <select
                    value={fund}
                    onChange={(e) => setFund(e.target.value)}
                    style={{ ...inputStyle, color: fund ? "#334155" : "#94a3b8" }}
                  >
                    <option value="">Select Fund</option>
                    <option value="equity">Equity</option>
                    <option value="debt">Debt</option>
                    <option value="hybrid">Hybrid</option>
                  </select>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <label style={labelStyle}>Category</label>
                  <select
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    style={inputStyle}
                  >
                    <option value="all">All</option>
                    <option value="equity">Equity</option>
                    <option value="debt">Debt</option>
                    <option value="hybrid">Hybrid</option>
                  </select>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <label style={labelStyle}>RTA</label>
                  <select
                    value={rta}
                    onChange={(e) => setRta(e.target.value)}
                    style={inputStyle}
                  >
                    <option value="all">All</option>
                    <option value="cams">CAMS</option>
                    <option value="karvy">Karvy</option>
                    <option value="franklink">Franklin</option>
                  </select>
                </div>
              </div>
            </div>

            {/* View Type Section */}
            <div style={{ marginBottom: "20px" }}>
              <span style={{ fontWeight: 700, color: "#334155", fontSize: "15px" }}>
                View Type :
              </span>
              <div className="d-flex flex-wrap align-items-center gap-4 mt-2">
                {/* Radio: On Screen / XLS */}
                <div className="d-flex align-items-center gap-3">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", color: "#334155" }}>
                    <input
                      type="radio"
                      name="viewType"
                      checked={viewType === "on-screen"}
                      onChange={() => setViewType("on-screen")}
                      style={{ accentColor: "#06d1c6", width: 18, height: 18 }}
                    />
                    On Screen
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", color: "#334155" }}>
                    <input
                      type="radio"
                      name="viewType"
                      checked={viewType === "xls"}
                      onChange={() => setViewType("xls")}
                      style={{ accentColor: "#06d1c6", width: 18, height: 18 }}
                    />
                    XLS
                  </label>
                </div>

                {/* Toggle: Detail / Brief */}
                <div className="d-flex align-items-center gap-2">
                  <span style={{ ...labelStyle, marginBottom: 0 }}>Detail</span>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={detailBrief === "brief"}
                    onClick={() => setDetailBrief((v) => (v === "detail" ? "brief" : "detail"))}
                    style={{
                      width: 48,
                      height: 26,
                      borderRadius: 13,
                      border: "none",
                      background: detailBrief === "brief" ? "#06d1c6" : "#e2e8f0",
                      cursor: "pointer",
                      position: "relative",
                      padding: 0,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: 3,
                        left: detailBrief === "detail" ? 3 : 25,
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        background: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        transition: "left 0.2s ease",
                      }}
                    />
                  </button>
                  <span style={{ ...labelStyle, marginBottom: 0 }}>Brief</span>
                </div>

                {/* Toggle: Show All Folios / Show Active Folios */}
                <div className="d-flex align-items-center gap-2">
                  <span style={{ ...labelStyle, marginBottom: 0 }}>Show All Folios</span>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={showFolios === "active"}
                    onClick={() => setShowFolios((v) => (v === "active" ? "all" : "active"))}
                    style={{
                      width: 48,
                      height: 26,
                      borderRadius: 13,
                      border: "none",
                      background: showFolios === "active" ? "#06d1c6" : "#e2e8f0",
                      cursor: "pointer",
                      position: "relative",
                      padding: 0,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: 3,
                        left: showFolios === "all" ? 3 : 25,
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        background: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        transition: "left 0.2s ease",
                      }}
                    />
                  </button>
                  <span style={{ ...labelStyle, marginBottom: 0 }}>Show Active Folios</span>
                </div>
              </div>
            </div>

            {/* Apply Button */}
            <div className="text-center mt-4">
              <button
                type="button"
                onClick={handleApply}
                style={{
                  background: "#06d1c6",
                  color: "#fff",
                  border: "none",
                  padding: "10px 32px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(6, 209, 198, 0.3)",
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
